import api from './api';

class WebsiteSubscriptionService {
  // Check subscription status
  async getSubscriptionStatus() {
    try {
      const response = await api.get('/website-subscription/status');
      return response.data;
    } catch (error) {
      console.error('Error getting subscription status:', error);
      throw error;
    }
  }

  // Subscribe to website add-on
  async subscribe(paymentMethodId) {
    try {
      const response = await api.post('/website-subscription/subscribe', {
        payment_method_id: paymentMethodId
      });
      return response.data;
    } catch (error) {
      console.error('Error subscribing to website add-on:', error);
      throw error;
    }
  }

  // Cancel subscription
  async cancelSubscription() {
    try {
      const response = await api.post('/website-subscription/cancel');
      return response.data;
    } catch (error) {
      console.error('Error canceling subscription:', error);
      throw error;
    }
  }
}

export default new WebsiteSubscriptionService();
